import styled from 'styled-components';

export const Title = styled.h1`
	${({ theme }) => theme.fonts.headings.title4};
	padding: 0;
`;

export const BaseWrapper = styled.div`
	position: relative;
	background: ${({ theme }) => theme.colors.decorativeMarketing};
	display: flex;
	flex-direction: column;
	flex: 1 0 0;
	color: ${({ theme }) => theme.colors.text.onDark.enabled};
	${({ theme }) => theme.fonts.text.text3};
	height: 100%;
	max-height: 100%;
	overflow: auto;
`;

export const BaseTopContent = styled.div`
	display: flex;
	width: 100%;
	gap: ${({ theme }) => theme.spacings.xsmall};
`;
